import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-drag-drop',
  templateUrl: './drag-drop.component.html',
  styleUrls: ['./drag-drop.component.scss']
})
export class DragDropComponent implements OnInit {
  @Input() assigned: Array<any>;
  @Input() unassigned: Array<any>;
  @Input() assignedHeading: string;
  @Input() unassignedHeading: string;
  @Input() loadingAssigned: boolean;
  @Input() loadingUnassigned: boolean;
  @Output() assignedSearch = new EventEmitter();
  @Output() unAssignedSearch = new EventEmitter();
  @Output() scrolledAssigned = new EventEmitter();
  @Output() scrolledUnassigned = new EventEmitter();

  searchAssigned = '';
  searchUnassigned = '';

  // @EventEmitter('')
  constructor(private translate: TranslateService) { }

  ngOnInit() {
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer !== event.container) {
      Swal.fire({
        title: this.translate.instant('confirm') + '?',
        // text: this.translate.instant('do_you_want_to_block') + ' Gills?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.translate.instant('OK')
      }).then((result) => {
        if (result.value) {
          transferArrayItem(event.previousContainer.data, event.container.data,
            event.previousIndex, event.currentIndex);
        }
      });
    } else {
      // moveItemInArray(this.assigned, event.previousIndex, event.currentIndex);
    }
  }
  emitSearch(ev: KeyboardEvent, type) {
    if (ev.key.toLowerCase() === 'enter' && type === 'assign') {
    this.assignedSearch.emit({event: ev, searchKey: this.searchAssigned});
    } else if (ev.key.toLowerCase() === 'enter' && type === 'unassign') {
      this.unAssignedSearch.emit({event: ev, searchKey: this.searchUnassigned});
    }
  }

}
